import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { SharedModule } from '../shared/shared.module';

 @Component({
    imports: [SharedModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
